import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#home-affordability-app-v2', App);
